<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<el-card class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span><strong>MAINTENANCE REPORT</strong></span>
					</div>
					<div>
						<div class="mb-3" style="margin-top:-21px;">   
							<el-tabs type="border-card" v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
									<MaintenanceReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
				</el-card>	
			</div>
		</div>
	</div>
</template>

<script>

import Bright from '@/components/page/Bright.js'
import MaintenanceReportTab from '@/views/pages/MaintenanceReport/MaintenanceReportTab.vue'

export default
{
	extends: Bright,
	components: { 
		MaintenanceReportTab,
	},

	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '2',
			tabName: 'storeupdate', 
			tabList:[
				//{label:'ATG', name: 'atg', index: '0' },
				//{label:'SPBU Update', name: 'spbuupdate', index: '1' },
				{label:'Store Update', name: 'storeupdate', index: '2' },
				//{label:'Outlets', name: 'outlets', index: '3' },
				//{label:'Self Service', name: 'selfservice', index: '4' },
			],
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
    },
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>